// Added by Sejune Oh on 2019-08-05
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { makeAutoObservable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Root Store
import RootStore from '../../index'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Util
import { setCookie, getCookie } from '@/helper/util'

// Logger
import { AuthorizedUserElementProps } from '../UserAuth'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class UserPrefStore {
    root?: RootStore

    userId?: string
    userName?: string

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    constructor(root: RootStore) {
        this.root = root
        makeAutoObservable(this)
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    prefClear = () => {
        this.userId = undefined
        this.userName = undefined
    }

    prefSet = ({ id, username }: AuthorizedUserElementProps) => {
        this.userId = id
        this.userName = username
        this.refreshRowsPerPage()
    }

    get rowsPerPage(): number | null {
        if (!this.userId) return null

        const rowsPerPage = getCookie(`ROWS_PER_PAGE_${this.userId}`)
        return rowsPerPage ? parseInt(rowsPerPage) : null
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    setRowsPerPage = (pageCount: string) => {
        setCookie({
            name: `ROWS_PER_PAGE_${this.userId}`,
            expHours: 24 * 365,
            value: pageCount,
        })
    }

    refreshRowsPerPage = () => {
        const rowsPerPage = this.rowsPerPage
        if (rowsPerPage) this.setRowsPerPage(rowsPerPage.toString())
    }
}
